import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Stack,
} from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IDocTypeConvention } from '../../../../redux/import/sliceDocnumberSidepanel';

/** Dropdown component for sidepanel */
export default ({ value, handleChange, options }: ISidepanelDropdownProps) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'sidepanel' });

    const example = useMemo(() => {
        return options.find(item => item.key === value)?.example ?? '';
    }, [value]);

    return (
        <Stack>
            <FormControl fullWidth size='small'>
                <InputLabel id='select-label'>{t('documentNumberConfiguration')}</InputLabel>
                <Select
                    labelId='select-label'
                    id='sidepanel-select'
                    label={t('documentNumberConfiguration')}
                    value={value}
                    onChange={handleChange}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: '14px',
                        },
                    }}
                >
                    {options.map(item => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            sx={{
                                fontSize: '14px',
                            }}
                        >
                            {item.key}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>
                    {t('example')}: {example}
                </FormHelperText>
            </FormControl>
        </Stack>
    );
};

/**
 * Interface that describes the props for a SidepanelDropdown component.
 */
export interface ISidepanelDropdownProps {
    value: string;
    handleChange: (event: SelectChangeEvent) => void;
    options: IDocTypeConvention[];
}
